import { gql } from "@grandvisionhq/graphql";
const GET_CART_EXPRESS_PAYMENT_METHODS = gql`
  query CartExpressPaymentMethods($cartId: ID!) {
    cartExpressPaymentMethods(cartId: $cartId) {
      name
      psp
      brands
      configuration {
        ... on GooglePayPaymentMethodConfiguration {
          merchantId
          gatewayMerchantId
        }
        ... on ApplePayPaymentMethodConfiguration {
          merchantId
          merchantName
        }
      }
    }
  }
`;
export {
  GET_CART_EXPRESS_PAYMENT_METHODS
};
//# sourceMappingURL=get-cart-express-payment-methods.js.map
